import React from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { EditGeneralDetailsFlowSchema } from '../schemas/editGeneralDetailsFlowSchema'
import { Field, SwitchRoot, SwitchThumb } from '@workwhile/ui'

export const PastShiftCreationAllowedField = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<EditGeneralDetailsFlowSchema>()

  const { field } = useController({
    control,
    name: 'pastShiftCreationAllowed',
  })

  return (
    <Field
      label="Allow past shift creation"
      error={errors.pastShiftCreationAllowed?.message?.toString()}
      // Intentionally disabled. This should work, unsure why it's throwing an error
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      mt={3}
      width="50%"
    >
      <SwitchRoot
        checked={field.value}
        onCheckedChange={(value) => field.onChange(value)}
        aria-label="Allow past shift creation"
      >
        <SwitchThumb>{field.value ? 'Yes' : 'No'}</SwitchThumb>
      </SwitchRoot>
    </Field>
  )
}
